import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.interactive_area.breadcrumb.interactive_label1'),
    link: '/application',
  },
  {
    label: t('pages.interactive_area.breadcrumb.interactive_label2'),
  },
];
